import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      s1q() {
        throw SerializationException().m1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      t1q() {
        return true;
      }
      u1q() {
        return null;
      }
      v1q() {
        var tmp = this.s1q();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      w1q() {
        var tmp = this.s1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      x1q() {
        var tmp = this.s1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      y1q() {
        var tmp = this.s1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      z1q() {
        var tmp = this.s1q();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      a1r() {
        var tmp = this.s1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      b1r() {
        var tmp = this.s1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      c1r() {
        var tmp = this.s1q();
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      d1r() {
        var tmp = this.s1q();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      e1r(enumDescriptor) {
        var tmp = this.s1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      f1r(descriptor) {
        return this;
      }
      g1r(deserializer, previousValue) {
        return this.h1r(deserializer);
      }
      i1r(descriptor) {
        return this;
      }
      j1r(descriptor) {
      }
      k1r(descriptor, index) {
        return this.v1q();
      }
      l1r(descriptor, index) {
        return this.w1q();
      }
      m1r(descriptor, index) {
        return this.x1q();
      }
      n1r(descriptor, index) {
        return this.y1q();
      }
      o1r(descriptor, index) {
        return this.z1q();
      }
      p1r(descriptor, index) {
        return this.a1r();
      }
      q1r(descriptor, index) {
        return this.b1r();
      }
      r1r(descriptor, index) {
        return this.c1r();
      }
      s1r(descriptor, index) {
        return this.d1r();
      }
      t1r(descriptor, index) {
        return this.f1r(descriptor.u1p(index));
      }
      u1r(descriptor, index, deserializer, previousValue) {
        return this.g1r(deserializer, previousValue);
      }
      w1r(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.r1m().g1p();
        var tmp;
        if (isNullabilitySupported || this.t1q()) {
          tmp = this.g1r(deserializer, previousValue);
        } else {
          tmp = this.u1q();
        }
        return tmp;
      }
    }
    protoOf($).v1r = decodeSerializableElement$default;
    protoOf($).h1r = decodeSerializableValue;
    protoOf($).y1r = decodeSequentially;
    protoOf($).a1s = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
